export enum CheckInResultDisplayType {
  Toast = 'Toast',
  Dialog = 'Dialog',
}
